<script setup lang="ts">
import AppShell from "../Layout/AppShell.vue"
import CustomerForm from "./components/CustomerForm.vue"

defineProps<{
  customer: {
    id?: number | null
    company_id: number | ""
    name: string
    person_type: string
    document: string
    email: string
    phone: string
    addresses: Array<{
      id?: number | null
      label: string
      street: string
      number: string
      complement: string
      district: string
      city: string
      state: string
      zip_code: string
    }>
  }
  companies: Array<{ id: number; name: string }>
  errors?: Record<string, string[]>
}>()
</script>

<template>
  <AppShell>
    <CustomerForm
      mode="edit"
      title="Editar cliente"
      subtitle="Atualize os dados cadastrais e os enderecos vinculados."
      :customer="customer"
      :companies="companies"
      :errors="errors"
    />
  </AppShell>
</template>

